import { render, staticRenderFns } from "./ratings.vue?vue&type=template&id=39b1497a&scoped=true&"
import script from "./ratings.vue?vue&type=script&lang=js&"
export * from "./ratings.vue?vue&type=script&lang=js&"
import style0 from "./ratings.vue?vue&type=style&index=0&id=39b1497a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b1497a",
  null
  
)

export default component.exports